import React from 'react';
import { motion } from 'framer-motion';
import { 
  UserCheck, 
  Link, 
  Gift, 
  DollarSign
} from 'lucide-react';

const HowItWorks: React.FC = () => {
  const steps = [
    {
      icon: <UserCheck size={24} />,
      title: "Авторизация",
      description: "Войди через Steam за 10 секунд"
    },
    {
      icon: <Gift size={24} />,
      title: "Промокоды",
      description: "Генерируй бонусные коды"
    },
    {
      icon: <DollarSign size={24} />,
      title: "Доход",
      description: "До 20% с депозитов"
    },
  ];

  return (
    <section id="how-it-works" className="py-12 bg-tesla-black">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-3 text-white">
            Как начать зарабатывать?
          </h2>
          <p className="text-gray-400 mb-2">
            4 простых шага
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4 relative hover:bg-white/10 transition-all duration-300"
            >
              {/* Step number */}
              <div className="absolute -top-2 -right-2 w-5 h-5 bg-purple-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                {index + 1}
              </div>

              <div className="text-purple-400 mb-3 flex justify-center">
                {step.icon}
              </div>
              
              <h3 className="text-base font-semibold text-white mb-2 text-center">
                {step.title}
              </h3>
              
              <p className="text-gray-400 text-xs leading-relaxed text-center">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 